import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

export interface CategoryPillProps {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}

/**
 * A category filter chip for directory-style grids (assistants marketplace,
 * connectors directory). Active = inverted ink fill; monochrome by design.
 */
export function CategoryPill({ active, onClick, children }: CategoryPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-pill px-3.5 py-1.5 font-sans text-[13px] font-medium outline-none transition-colors duration-150 ease-house focus-visible:ring-[3px] focus-visible:ring-tint",
        active
          ? "bg-accent text-accent-ink"
          : "bg-bubble text-ink hover:bg-tint",
      )}
    >
      {children}
    </button>
  );
}
